import { type InstagramFeedOptions } from "@client/content/controls/Instragram/Feed/lib";
import {
  combinedSettingsSelector,
  createShallowEqualSelector,
  getSettingValueSelector,
  makeBorderStyleSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import * as React from "react";
import { createSelector } from "reselect";

export const makeFeedOptionsSelector = (): SettingsPropsParametricSelector => {
  const settingSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "instaToken", prop: "accessToken" },
    { name: "instaMethod", prop: "method" },
    { name: "itemsAmount", prop: "count" },
    { name: "queryTag", prop: "search" }
  ]);

  return createShallowEqualSelector([settingSelector], ({ method, search, ...settings }): InstagramFeedOptions => {
    return {
      ...settings,
      search: method === "getRecentTagged" ? search : "self",
      what: method === "getRecentTagged" ? "tags" : "users"
    };
  });
};

export const makeItemStyleSelector = (): SettingsPropsParametricSelector => {
  const borderStyleSelector = makeBorderStyleSelector(TargetSelector.Entity, "thumb");
  const thumbSpacingSelector = getSettingValueSelector(TargetSelector.Entity, "spacing", "thumb");
  return createSelector(
    [thumbSpacingSelector, borderStyleSelector],
    (thumbSpacing, border): React.CSSProperties => ({
      ...border,
      padding: thumbSpacing
    })
  );
};
